import React from 'react'
import { Span, Box, Label } from '..'
import { InputComponent, SearchComponent, PasswordComponent } from './styled'

const { Group } = InputComponent

const Input = ({
	className,
	onChange,
	name,
	value,
	valueCheckErr,
	label,
	color,
	style,
	placeholder,
	required,
	maxLength,
	type,
	error,
	addonAfter,
	disabled,
	notvalue,
	addonBefore,
	prefix,
}) => {
	return (
		<>
			{label && (
				<div style={{ marginTop: '5px' }}>
					<Label color={color}>
						{label} {required && <Span color='red'>*</Span>}
					</Label>
				</div>
			)}
			<InputComponent
				className={className}
				onChange={onChange}
				name={name}
				value={value}
				style={style}
				placeholder={placeholder}
				maxLength={maxLength}
				type={type}
				addonBefore={addonBefore}
				addonAfter={addonAfter}
				disabled={disabled}
				notvalue={notvalue ? 1 : 0}
				prefix={prefix}
			/>
			{((!value && error) || valueCheckErr) && (
				<Box>
					<Span color='red'>{error}</Span>
				</Box>
			)}
		</>
	)
}

const InputGroup = ({ compact, size, children }) => {
	return (
		<Group compact={compact} size={size}>
			{children}
		</Group>
	)
}

const InputSearch = ({
	onChange,
	placeholder,
	className,
	value,
	onPressEnter,
	onSearch,
	enterButton,
	name,
	style,
	loading,
}) => {
	return (
		<SearchComponent
			placeholder={placeholder}
			name={name}
			className={className}
			onChange={onChange}
			value={value}
			onPressEnter={onPressEnter}
			onSearch={onSearch}
			enterButton={enterButton}
			style={style}
			loading={loading}
			autoComplete='off'
		/>
	)
}

const InputPassword = ({
	required,
	name,
	className,
	defaultValue,
	value,
	onChange,
	onKeyDown,
	placeholder,
	type,
	style,
	disabled,
	ref,
	error,
	minLength,
}) => {
	return (
		<>
			<PasswordComponent
				type={type}
				required={required}
				name={name}
				onChange={onChange}
				onKeyDown={onKeyDown}
				placeholder={placeholder}
				className={className}
				defaultValue={defaultValue}
				value={value}
				style={style}
				disabled={disabled}
				ref={ref}
				minLength={minLength}
			/>
			{error && (
				<Box>
					<Span color='red' style={{ fontSize: '14px' }}>
						{error}
					</Span>
				</Box>
			)}
		</>
	)
}

Input.Group = InputGroup
Input.Search = InputSearch
Input.Password = InputPassword

export { Input }
